import React from "react";
import { Link } from "react-router-dom";
import {
  FiHelpCircle,
  FiShield,
  FiFileText,
  FiClipboard,
  FiMapPin,
  FiCheckSquare,
} from "react-icons/fi";
import "./footer.css";
import UblLogo from "../../assets/images/ubl-logo.gif";
// Import store images
import IosImage from "../../assets/images/app-store-1.png";
import AndroidImage from "../../assets/images/google-play.png";


const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="footer">
      <div className="footer-content">
        {/* Left column: Link lists */}
        <div className="links-container">
          <div className="foot-links">
            <Link to="/faq" className="foot-link" onClick={scrollToTop}>
              <FiHelpCircle /> FAQ
            </Link>
            <Link to="/privacy" className="foot-link" onClick={scrollToTop}>
              <FiShield /> Privacy Policy
            </Link>
            <Link to="/terms" className="foot-link" onClick={scrollToTop}>
              <FiFileText /> Terms & Conditions
            </Link>
          </div>

          <div className="foot-links">
            <Link to="/posterlist" className="foot-link" onClick={scrollToTop}>
              <FiCheckSquare /> Approved Poster List
            </Link>
            <Link to="/abstract" className="foot-link" onClick={scrollToTop}>
              <FiClipboard /> Abstract Submissions Guideline
            </Link>
            <Link to="/travel" className="foot-link" onClick={scrollToTop}>
              <FiMapPin /> Travel Information
            </Link>
          </div>
        </div>

        {/* Right column: UBL Logo and Store Icons */}
        <div className="ubl-logo-container">
          <h3 className="payment-partner">Our Payment Partner</h3>
          <img src={UblLogo} alt="UBL Pay" className="ubl-logo" />
        </div>
      </div>
      {/* Store icons added under the UBL logo */}
      <h3 className="get-our-app">Get Our Mobile App on Apple's AppStore or Google's PlayStore</h3>
      <div className="store-icons">
        <a
          href="https://apps.apple.com/dz/app/smdc-international-conference/id6743955080"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={IosImage}
            alt="Download on the App Store"
            className="store-icon"
          />
        </a>
        <a
          href="https://play.google.com/store/apps/details?id=com.smdc.conferenceApp2"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={AndroidImage}
            alt="Get it on Google Play"
            className="store-icon"
          />
        </a>
      </div>
    </div>
  );
};

export default Footer;
